/**
 * 本地存储管理
 * 2021-08-12
 */

const IsSupport = (() => {
  if(typeof window == "undefined")
    return false;
  const temp = ["__test_browser__", "hello world"];
  if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
    try {
      localStorage.setItem(temp[0], temp[1]);
      if (localStorage.getItem(temp[0]) !== temp[1]) {
        //隐身模式不支持
        console.error("【logErr】Your browser is in a stealth mode and does not support LocalStorage.");
        return false;
      } else {
        //'正常模式'
        localStorage.removeItem(temp[0]);
        return true;
      }
    } catch (e) {
      //出错了不支持
      console.error("【logErr】Unknown error from LocalStorage test.");
      return false;
    }
  } else {
    //不支持
    console.error("【logErr】Your browser does not support LocalStorage.");
    return false;
  }
})();

const keyList = {
  //本地存储的列表，不在列表中的属性插入不了
  token: "token", //存储token
  lang: "lang", //存储语言信息
  clientCode: "clientCode", //设备唯一code【废弃】放到cookie中
  //以下是配置，清除缓存
  lastUrl: "lastUrl", //存储上一步链接，
  assist: "assist", //当前货币汇率信息
  hideZero: "hideZero", //隐藏0资产标识
  hideCanceled: "hideCanceled", //隐藏隐藏已撤销委托
  hideSmall: "hideSmall", //隐藏小额资产标识
  hideSmallAll: "hideSmallAll",
  hideSmallSpot: "hideSmallSpot",
  hideSmallMargin: "hideSmallMargin",
  hideSmallFuture: "hideSmallFuture",
  hideSmallFinance: "hideSmallFinance",
  hideFund: "hideFund", //隐藏资产标识
  countryCode: "countryCode", //用户的手机号国家编码 譬如 "86"
  kLineInterval: "kLineInterval", //K线时间间隔 譬如 "1D"
  //proTheme: "proTheme", //专业版主题，Dark=黑色(默认)，Light=白色【废弃】放到cookie中
  market: "market", //当前现货市场名称 譬如 "btc_usdt"
  marketConfig: "marketConfig", //当前市场配置 譬如 {md5: "asfsdf", list: {...}}
  currencyList: "currencyList", //币种列表 譬如 {version: "asfsdf", currencies: [{...}]}
  recommendedCurrencyList: "recommendedCurrencyList", //推荐币种列表，已按用户/IP/充提条件过滤
  marketGroup: "marketGroup", //当前现货市场分组名称 譬如 "usds" 板块为 'zone'
  marketZoneId: "marketZoneId", //现货市场板块ID，当现货市场分组名称 板块 时有效
  leverMarket: "leverMarket", //当前杠杆市场名称 譬如 "xwc_sxc"
  leverMarketGroup: "leverMarketGroup", //当前杠杆市场分组名称 譬如 "usdt"
  etfMarket: "etfMarket", //当前ETF市场名称 譬如 "btc3l_usdt"
  usdtContractMarket: "usdtContractMarket", //当前U本位合约市场名称 譬如 "btc_usdt"
  coinContractMarket: "coinContractMarket", //当前币本位合约市场名称 譬如 "btc_usd"
  quantoContractMarket: "quantoContractMarket", //当前全币种合约市场名称 譬如 "btc_xwc"
  contractLeverage: "contractLeverage", //合约杠杆倍数记录对象 譬如 {btc_usdt: 10}
  adList: "adList", //广告本地缓存信息
  etfIndexMarket: "etfIndexMarket", //etf指数市场名称,譬如 "index-btc_usdt"
  xtTipNoAlert: "xtTipNoAlert", //不再提示 XT智能链开放对话框 譬如 "1",
  depositeTip: "depositeTip", //储存充值提示语信息 对象形式 例如depositeTip.币种.链 == 1 就是设置过得 =>
  depositeTipArr: "depositeTipArr", //存 id 了改为数组
  bindGoogleTip: "bindGoogleTip", //引导设置谷歌验证码提示，譬如 "1646019963315"
  otcFiat: "otcFiat", // 储存OTC 法币
  marketType: "coinMarket", // 行情类型 譬如 "coinMarket"：币币行情
  etfIndexGroup: "indexGroup", // etf指数分组
  etfGuideKnown: "etfGuideKnown", //etf引流，已经知道市场对象，譬如：{btc_usdt: 1},
  //theme: "theme", //【废弃】放到cookie中
  countryId: "countryId", //选择的国家ID,如：香港（206）
  contractMarketType: "usd", //当前合约市场分组名称 譬如 "usd" U本位合约
  tvChartSpot: "xt.tradingview.spot.chart", //现货tradingview持久化
  "client-device-id": "client-device-id",
  loginType: "loginType", //登录方式，email 或 mobile
  country: "country", //国家存储
  red_packet_has_set_pwd: "red_packet_has_set_pwd",
  uBasedSymbols: "uBasedSymbols", //合约u本位交易对列表 譬如 {version: "asfsdf", symbols: [{...}]}
  coinBasedSymbols: "coinBasedSymbols", //合约币本位交易对列表 譬如 {version: "asfsdf", symbols: [{...}]}
  assetConvert: "assetConvert", //资产折算币种(btc/usdt)
  cfdMarket: "cfdMarket", // 差价合约市场
  marketFavorites: "marketFavorites", //行情自选：本地有序收藏列表（含置顶顺序）
};

export default {
  keyList,
  get(key) {
    if (!IsSupport) return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.get 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    const itemValue = localStorage.getItem(itemKey);
    let result;
    try {
      result = JSON.parse(itemValue);
    } catch (e) {
      result = itemValue;
    }
    return result || "";
  },
  set(key, value) {
    if (!IsSupport) return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.set 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    try {
      localStorage.setItem(itemKey, JSON.stringify(value));
    } catch (e) {
      localStorage.setItem(itemKey, value);
    }
  }, //对象会被压成字符串
  remove(key) {
    if (!IsSupport) return;
    const itemKey = keyList[key];
    if (!itemKey) return console.log("%c$storage.remove 键名不在列表内: %c" + key, "color: #ac2925", "color: red");

    localStorage.removeItem(itemKey);
  },
  clear() {
    if (!IsSupport) return;
    const token = this.get("token");
    // const lang = this.get("lang");
    const clientCode = this.get("clientCode");
    localStorage.clear();
    token && this.set("token", token);
    // lang && this.set("lang", lang);
    clientCode && this.set("clientCode", clientCode);
    return true;
  },
};
